var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    { staticClass: "border-b border-gray-200 hover:bg-gray-100" },
    [
      _c(
        "td",
        { staticClass: "py-3 px-3 text-left whitespace-nowrap cursor-pointer" },
        [
          _c(
            "div",
            {
              staticClass: "flex items-center",
              on: {
                click: function ($event) {
                  return _vm.viewProject(_vm.project)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c("DefaultProjectImage", {
                    staticClass: "w-2 h-2 rounded-full",
                    attrs: { title: _vm.project.name },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "text-xs" }, [
                _vm._v(_vm._s(_vm.project.name)),
              ]),
            ]
          ),
        ]
      ),
      _c("td", { staticClass: "py-3 pl-0 text-left" }, [
        _c("div", { staticClass: "flex text-xs" }, [
          _c(
            "span",
            [
              _c("BudgetRange", {
                staticClass: "text-label",
                attrs: {
                  minBudget: _vm.project.min_budget,
                  maxBudget: _vm.project.max_budget,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("td", { staticClass: "py-3 pl-0 text-left" }, [
        _c("div", { staticClass: "inline-flex text-xs text-left" }, [
          _vm._v(" " + _vm._s(_vm.startDate) + "-" + _vm._s(_vm.endDate) + " "),
        ]),
      ]),
      _c("td", { staticClass: "py-3 px-0 text-left" }, [
        _c("div", { staticClass: "text-xs text-left" }, [
          _vm._v(" " + _vm._s(_vm.totalContractors) + " "),
        ]),
      ]),
      _c("td", { staticClass: "py-3 px-0 text-left" }, [
        _c("div", { staticClass: "text-xs" }, [
          _vm._v(" " + _vm._s(_vm.totalActivities) + " "),
        ]),
      ]),
      _c("td", { staticClass: "py-3 pl-1 text-left" }, [
        _c("div", { staticClass: "flex item-left justify-left" }, [
          _c(
            "div",
            {
              staticClass:
                "w-4 mr-4 transform hover:text-purple-500 hover:scale-110",
              on: {
                click: function ($event) {
                  return _vm.viewProject(_vm.project)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "21",
                    height: "14",
                    viewBox: "0 0 21 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.2558 0C5.59408 0 1.61296 2.90267 0 7C1.61296 11.0973 5.59408 14 10.2558 14C14.9175 14 18.8987 11.0973 20.5116 7C18.8987 2.90267 14.9175 0 10.2558 0ZM10.2558 11.6667C7.68254 11.6667 5.59408 9.576 5.59408 7C5.59408 4.424 7.68254 2.33333 10.2558 2.33333C12.8291 2.33333 14.9175 4.424 14.9175 7C14.9175 9.576 12.8291 11.6667 10.2558 11.6667ZM10.2558 4.2C8.70812 4.2 7.45877 5.45067 7.45877 7C7.45877 8.54933 8.70812 9.8 10.2558 9.8C11.8035 9.8 13.0529 8.54933 13.0529 7C13.0529 5.45067 11.8035 4.2 10.2558 4.2Z",
                      fill: "#1A7BEE",
                    },
                  }),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "w-4 mr-2 transform hover:text-purple-500 hover:scale-110",
              on: {
                click: function ($event) {
                  return _vm.editProject(_vm.project)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0 11.247V13.6112C0 13.8289 0.171088 14 0.388836 14H2.75296C2.85406 14 2.95515 13.9611 3.02514 13.8833L11.5173 5.39895L8.60106 2.48268L0.116651 10.9671C0.0388837 11.0448 0 11.1382 0 11.247ZM13.7726 3.1437C13.8447 3.07175 13.9019 2.98629 13.9409 2.89222C13.9799 2.79814 14 2.69729 14 2.59544C14 2.49359 13.9799 2.39274 13.9409 2.29866C13.9019 2.20458 13.8447 2.11912 13.7726 2.04718L11.9528 0.227426C11.8809 0.155333 11.7954 0.0981367 11.7013 0.059112C11.6073 0.0200872 11.5064 0 11.4046 0C11.3027 0 11.2019 0.0200872 11.1078 0.059112C11.0137 0.0981367 10.9282 0.155333 10.8563 0.227426L9.43316 1.65057L12.3494 4.56684L13.7726 3.1437V3.1437Z",
                      fill: "#1A7BEE",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }